import React from 'react';
import './HeaderPrint.scss';

const HeaderPrint = ({persianTitle, englishTitle, color}) => {

  const logo = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="27"
    fill="none"
    viewBox="0 0 34 27"
  >
    <g clipPath="url(#clip0_36_34)">
      <path
        fill="#B9B9B9"
        d="M9.962 20.52H5.941C2.665 20.52 0 17.896 0 14.67V1.35C0 .605.614 0 1.371 0s1.37.605 1.37 1.35v13.32c0 1.737 1.436 3.15 3.2 3.15h4.021c1.764 0 3.2-1.413 3.2-3.15v-3.96c0-1.737-1.436-3.15-3.2-3.15h-.365a1.361 1.361 0 01-1.371-1.35c0-.745.614-1.35 1.37-1.35h.366c3.276 0 5.941 2.624 5.941 5.85v3.96c0 3.226-2.665 5.85-5.94 5.85z"
      ></path>
      <path
        fill="url(#paint0_linear_36_34)"
        d="M9.962 4.85h-.365c-.757 0-1.371.604-1.371 1.35 0 .744.614 1.35 1.37 1.35h.366c1.059 0 1.995.509 2.578 1.29a19.88 19.88 0 002.373-1.372 5.966 5.966 0 00-4.95-2.619z"
      ></path>
      <path
        fill="#B9B9B9"
        d="M7.952 12.42a1.361 1.361 0 01-1.371-1.35V5.85C6.58 2.624 9.246 0 12.52 0h5.302c.756 0 1.37.605 1.37 1.35 0 .745-.614 1.35-1.37 1.35H12.52c-1.764 0-3.198 1.413-3.198 3.15v5.22c0 .745-.615 1.35-1.371 1.35zM16.543 27h-3.656a1.361 1.361 0 01-1.37-1.35c0-.745.613-1.35 1.37-1.35h3.656c1.764 0 3.199-1.413 3.199-3.15v-5.22c0-.745.614-1.35 1.37-1.35.758 0 1.372.605 1.372 1.35v5.22c0 3.226-2.665 5.85-5.941 5.85zM27.694 20.52c-.757 0-1.371-.605-1.371-1.35V6.21c0-.745.614-1.35 1.37-1.35.757 0 1.371.605 1.371 1.35v12.96c0 .745-.614 1.35-1.37 1.35z"
      ></path>
      <path
        fill="#B9B9B9"
        d="M21.113 12.42a1.361 1.361 0 01-1.371-1.35V5.85c0-3.226 2.665-5.85 5.94-5.85h6.947C33.386 0 34 .605 34 1.35c0 .745-.614 1.35-1.371 1.35h-6.946c-1.764 0-3.2 1.413-3.2 3.15v5.22c0 .745-.613 1.35-1.37 1.35z"
      ></path>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_36_34"
        x1="12.664"
        x2="10.074"
        y1="8.881"
        y2="4.329"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B9B9B9"></stop>
        <stop offset="1" stopColor="#858585"></stop>
      </linearGradient>
      <clipPath id="clip0_36_34">
        <path fill="#fff" d="M0 0H34V27H0z"></path>
      </clipPath>
    </defs>
  </svg>

  return (
    <div className='header-print'>
      <div className='top_rectangle' style={{background: color}}></div>
      <div className='header_content' style={{borderLeft: `16px solid ${color}`, borderRight: `16px solid ${color}`}}>
        <h2 className='persian_title iransans'>{persianTitle}</h2>
        {logo}
        <h2 className='english_title iransans'>{englishTitle}</h2>
      </div>
    </div>
  );
};

export default HeaderPrint;